module.exports = __webpack_public_path__ + "static/media/banner-app-responsive-svg.18c5cbec.svg";